'use client';

import { Flex, Text } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import { useOnboardingStore, useOrgStore } from 'stores/rootStore';

const AddBusinessStepTitle = () => {
  const orgStore = useOrgStore();
  const onboardingStore = useOnboardingStore();
  const selectedOrg = orgStore.orgs.find((o) => o.id === onboardingStore.selectedOrgId);
  const orgName = selectedOrg?.name;

  return (
    <Flex flexDirection="column">
      <Text>Add a business</Text>
      {orgName != null && (
        <Text fontSize="xs" color="text.secondary" fontWeight="normal">
          {orgName}
        </Text>
      )}
    </Flex>
  );
};

export default observer(AddBusinessStepTitle);
